import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MSMEEventEnrollmentModel } from '../../../../../shared/models/MSMEEventEnrollmentModel';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { catchError, of } from 'rxjs';
import { ParticipantListModel } from '../../../../../shared/models/ParticipantListModel';

@Component({
  selector: 'app-vieweventdetails',
  templateUrl: './vieweventdetails.component.html',
  styleUrl: './vieweventdetails.component.css'
})
export class VieweventdetailsComponent {
  eventForm: FormGroup;
  participantsList: { ParticipantName: string; Designation: string; MobileNumber: string; }[] = [];
  private enrollmentCounter: number = 1;
  eventId = sessionStorage.getItem("EventId");
  eventObj!: MSMEEventEnrollmentModel;
  participantObj!: ParticipantListModel;
  msmeUserId = sessionStorage.getItem('msMeUserId');
  msmeUserName = sessionStorage.getItem('msMeUserName');

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService,
    private toastrService: ToastrService,) {
    this.eventForm = this.fb.group({
      participantName: ['', [Validators.required, Validators.pattern(this.commonService.nameWithSpacePattern)]],
      participantDesignation: ['', Validators.required],
      participantMobile: ['', [Validators.required, Validators.pattern(this.commonService.mobilePattern)]],
    });
  }
  get f() {
    return this.eventForm.controls;
  }

  ngOnInit(): void {
    if (this.eventId) {
      this.LoadDetails(this.eventId);
      this.LoadParticipantsDetails();

    } else {
      this.toastrService.error("EventId is null. Cannot load details.");
    }
  }

  LoadDetails(EventId: string) {
    var dtoEventID = { EventId }
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETEVENTFORENROLLMENT, dtoEventID ).subscribe(
      (result: MSMEEventEnrollmentModel) => {
        if (result.status) {
          this.eventObj = {
            status: result.status,
            message: result.message,
            list1: result.list1.length > 0 ? [result.list1[0]] : [],
            list2: result.list2,
            list3: result.list3
          };
        } 
      }
    );
  }

  LoadParticipantsDetails() {
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETENROLLEDPARTICIPANTLIST, {
      EventId: this.eventId,
      MsMeUserId: this.msmeUserId }).subscribe(
      (result: ParticipantListModel) => {
        if (result.status) {
          this.participantObj = {
            status: result.status,
            message: result.message,
            data: result.data
          };
        } else {
          this.toastrService.info('No participants registered for this event yet');
        }
      }
    );
  }
  get participants(): FormArray {
    return this.eventForm.get('participants') as FormArray;
  } 
  
  onPressBack() {
    this.router.navigate(['/vieweventlist']);
  }
}
